module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Andrew Marriott was an army officer for over thirty years, \nseeing service in conflicts in Europe, the Middle East and West \nAfrica. He received a commendation for devotion to duty as a \nplatoon commander in Northern Ireland and was later awarded \nan MBE. He has since become an archaeologist and, after taking \ndegrees at the University of York, in 2018, he was awarded a \ndoctorate by Newcastle University.\n"), _c('br'), _c('br'), _vm._v(" \nHe is married with two daughters and lives in North Yorkshire. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 66
// module chunks = 0